import MentoringRejectedRequests from './MentoringRejectedRequests.vue';

export default MentoringRejectedRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/rejectedrequests/index.ts